<template>
  <div>
    <Card>
      <ui-logout :action-before-logout="beforeLogout" />
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const beforeLogout = () => {
  console.log('Action before logout');
};
</script>
